module.exports = __webpack_public_path__ + "img/02d@2x.1191a395.svg";